import { useCallback, useEffect, useState } from "react";

export interface SearchHistoryItem {
  query: string;
  searchType: string;
  timestamp: number;
}

const MAX_HISTORY_ITEMS = 20;
export const STORAGE_KEY = "search_history";

export function useSearchHistory() {
  const [history, setHistory] = useState<SearchHistoryItem[]>([]);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      try {
        setHistory(JSON.parse(saved));
      } catch (e) {
        console.error("Erro ao carregar histórico:", e);
      }
    }
  }, []);

  const persist = (items: SearchHistoryItem[]) => {
    setHistory(items);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  };

  const addToHistory = useCallback(
    (query: string, searchType: string) => {
      if (!query || query.length < 3) return;

      const newItem: SearchHistoryItem = {
        query,
        searchType,
        timestamp: Date.now(),
      };

      const updated = [
        newItem,
        ...history.filter(
          (item) => item.query !== query || item.searchType !== searchType
        ),
      ].slice(0, MAX_HISTORY_ITEMS);

      persist(updated);
    },
    [history]
  );

  const removeFromHistory = useCallback(
    (query: string) => {
      const updated = history.filter((item) => item.query !== query);
      persist(updated);
    },
    [history]
  );

  const clearHistory = useCallback(() => {
    setHistory([]);
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  const getFilteredHistory = useCallback(
    (searchType?: string) => {
      if (!searchType) return history;
      return history.filter((item) => item.searchType === searchType);
    },
    [history]
  );

  return {
    history,
    addToHistory,
    removeFromHistory,
    clearHistory,
    getFilteredHistory,
  };
}
